/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { Component } from 'react';
import Markdown from 'markdown-to-jsx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import BasicSkillsInverted from '../assets/results/basic_skills_inverted.svg';
import TechnologyInverted from '../assets/results/technology_inverted.svg';
import CollaborationInverted from '../assets/results/collaboration_inverted.svg';
import CognitiveStrategyInverted from '../assets/results/cognitive_strategy_inverted.svg';
import WiseCounselInverted from '../assets/results/wise_counsel_inverted.svg';
import BasicSkillsBucket from '../assets/results/basic_skills_bucket.svg';
import TechnologyBucket from '../assets/results/technology_bucket.svg';
import CollaborationBucket from '../assets/results/collaboration_bucket.svg';
import CognitiveStrategyBucket from '../assets/results/cognitive_strategy_bucket.svg';
import WiseCounselBucket from '../assets/results/wise_counsel_bucket.svg';
import BasicSkills from '../assets/results/basic_skills.svg';
import Technology from '../assets/results/technology.svg';
import Collaboration from '../assets/results/collaboration.svg';
import CognitiveStrategy from '../assets/results/cognitive_strategy.svg';
import WiseCounsel from '../assets/results/wise_counsel.svg';
import EmptyBucket from '../assets/results/empty_bucket.png';
import Heart from '../assets/results/heart.svg';
import HeartFilled from '../assets/results/heart_filled.svg';
import {
  speak, beelineText, updateUser,
} from '../actions';

class Buckets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: 'Cognitive Strategies',
      loadingPDF: false,
    };
  }

  makePdf = () => {
    this.setState({ selectedFilter: 'all' }, () => {
      const notDashboard = document.getElementById('scroll-container');

      /*
      This section scrolls the page to the bottom after the filter is set to 'all' and more buckets pop up.
      Without this, the user won't see the loading text at the bottom letting the them know that the download
      has started and that its a slow download.
      */

      // results on results page or favorites page
      if (notDashboard) {
        notDashboard.scrollTop = notDashboard.scrollHeight
        - window.innerHeight;

      // results on dashboard page
      } else {
        // There can be multiple survey results on one page, this deals with scrolling to the bottom of the right one
        document
          .getElementById('dashboard-body-container')
          .scroll(
            0,
            document.getElementById(`${this.props.pdfName} box`).offsetTop // scrolls to the beginning of the results page
            + document.getElementById(this.props.pdfName).scrollHeight // scrolls to bottom of results page
            - window.innerHeight // we want the bottom of the results page to be at the bottom of the browser, not the top
            + 200, // accounts for 100px padding on top and bottom of results div
          );
      }

      /* This section saves the page as a pdf */

      // get the div with the content to be downloaded
      const input = document.getElementById(this.props.pdfName).parentElement;

      // creates 'canvas' object, which then can easily be converted to pdf
      // the height attribute is reduced to crop out the download pdf button and the bottom padding (100px)
      html2canvas(input, { height: input.scrollHeight - document.getElementById('pdf-ignore').scrollHeight - 100 })
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          // scale image up/down to have a 1080px width
          const imgWidth = 1080;
          const imgHeight = canvas.height * (imgWidth / canvas.width);
          const orientation = imgWidth > imgHeight ? 'l' : 'p';
          const pdf = new JsPDF(orientation, 'px', [imgWidth, imgHeight], true);
          pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
          pdf.save(`${this.props.pdfName} Results.pdf`);
          this.setState({ loadingPDF: false });
        });
    });
  }

  handleFilter = (bucket) => {
    this.setState({ selectedFilter: bucket });
  }

  handleLike = (id) => {
    const likedBuckets = this.props.favoritedResults.slice();
    const index = likedBuckets.indexOf(id);
    if (index !== -1) {
      likedBuckets.splice(index, 1);
    } else {
      likedBuckets.push(id);
    }
    this.props.updateUser(this.props.userid, { favorited_results: likedBuckets });
  }

  renderBuckets = () => {
    const bucketIcons = {
      'Basic Skills': BasicSkillsBucket,
      Technology: TechnologyBucket,
      'Cognitive Strategies': CognitiveStrategyBucket,
      Collaboration: CollaborationBucket,
      'Wise Counsel': WiseCounselBucket,
    };
    const results = Object.keys(this.props.buckets)
      .filter((bucket) => {
        return bucket === this.state.selectedFilter || this.state.selectedFilter === 'all';
      })
      .reduce((workingResult, bucket) => {
        const newResults = this.props.buckets[bucket].map((result, i) => {
          const key = i + 1;
          return (
            <div className="box toolkit-box" key={key}>
              <div className="tool-header-container">
                <div className="tool-header-title">
                  <img src={bucketIcons[bucket]} alt="result-icon" />
                  <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>{result.title}</p>
                </div>
                <img
                  onClick={() => this.handleLike(result.id)}
                  src={this.props.favoritedResults.indexOf(result.id) !== -1 ? HeartFilled : Heart}
                  alt="heart"
                />
              </div>
              <div onClick={this.props.speak} className={`color tool-body ${this.props.speechEnabled && 'bolded'}`}>
                <Markdown>
                  {result.statement}
                </Markdown>
              </div>
            </div>
          );
        });
        workingResult.push(newResults);
        return workingResult;
      }, []);
    if (results.length === 0) {
      return (
        <div className="empty-bucket-container">
          <img src={EmptyBucket} alt="no results" />
          <p onClick={this.props.speak} className={`color result-text ${this.props.speechEnabled && 'bolded'}`}>If this bucket is empty it means you should prioritize solutions in the other buckets.</p>
        </div>
      );
    }
    return results;
  }

  renderBucketFilters = () => {
    const buckets = {
      'Basic Skills': BasicSkills,
      'Basic Skills Inverted': BasicSkillsInverted,
      Technology,
      'Technology Inverted': TechnologyInverted,
      'Cognitive Strategies': CognitiveStrategy,
      'Cognitive Strategies Inverted': CognitiveStrategyInverted,
      Collaboration,
      'Collaboration Inverted': CollaborationInverted,
      'Wise Counsel': WiseCounsel,
      'Wise Counsel Inverted': WiseCounselInverted,
    };
    const filters = [
      ['Cognitive Strategies', 'Technology', 'Basic Skills', 'Collaboration', 'Wise Counsel']
        .map((bucket, i) => {
          const key = i + 1;
          return (
            <button
              type="button"
              key={key}
              className={`toolkit-filter ${this.state.selectedFilter === bucket ? 'toolkit-selected' : ''}`}
              name={bucket}
              onClick={() => this.handleFilter(bucket)}
            >
              <img
                src={this.state.selectedFilter === bucket ? buckets[`${bucket} Inverted`] : buckets[bucket]}
                alt={bucket}
              />
              <p className="color">{bucket}</p>
            </button>
          );
        }),
      <button
        type="button"
        key="extra"
        className={`toolkit-filter ${this.state.selectedFilter === 'all' ? 'toolkit-selected' : ''}`}
        name="all"
        onClick={() => this.handleFilter('all')}
      >
        <p className="color">See all</p>
      </button>,
    ];
    return (
      <div className="toolkit-filter-container">
        {filters}
      </div>
    );
  }

  render() {
    return (
      <div id="Favorite">
        {this.renderBucketFilters()}
        <div className="toolkit-container">
          {this.renderBuckets()}
        </div>
        <div id="pdf-ignore">
          <div className="results-button-container">
            {this.props.location.pathname === '/dashboard' ? null
              : (
                <button
                  type="button"
                  className="results-page-back-button"
                  onClick={() => { this.props.history.push('/dashboard'); }}
                >
                  Back to dashboard
                </button>
              )}
            <button
              type="button"
              className="results-page-pdf-button"
              onClick={() => { this.setState({ loadingPDF: true }, this.makePdf); }}
            >
              Screenshot Results (PDF)
            </button>
          </div>
          {this.state.loadingPDF ? <p className="loading-pdf">Downloading PDF (this may take a minute)...</p> : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    userid: state.user.userid,
    speechEnabled: state.speech.enabled,
    favoritedResults: state.user.favoritedResults,
  }
);

export default connect(mapStateToProps, {
  speak, beelineText, updateUser,
})(withRouter(Buckets));
